const CREDITORNO_POS = 6
const DEBITORNO_POS = 4

export const getCredorNoFromSearchString = (searchString) => {
    return searchString.split('|')[CREDITORNO_POS]
}

export const getDebitorNoFromSearchString = (searchString) => {
    return searchString.split('|')[DEBITORNO_POS]
}